<template>
  <el-dialog
    title="群組訂閱管理"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                v-model="queryForm.qstr"
                placeholder="人員、頻道名稱、檔名"
                style="width:180px"
              ></el-input>
            </el-form-item>

            <el-form-item label=" " label-width="15px">
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="danger"
            @click="handleBatchUnsubs"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次刪除</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-user" /> 群組：{{
          groupName
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="subscriptions"
            v-loading="isLoading"
            ref="dataTable"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              type="index"
              :index="indexFormatter"
              prop="id"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="頻道名稱"
              prop="channel.name"
              sortable="custom"
              width="140"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.channel.color)">{{
                  scope.row.channel.name
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="訂閱位置" prop="path" width="220">
              <template #default="scope">
                <span v-if="isChannelSubs(scope.row)">
                  <img src="../../assets/icons/phone.svg" class="phoneicon" />
                  <span class="ml-1">
                    全頻道
                  </span>
                </span>
                <span v-else>
                  <img
                    v-if="!scope.row.asset.isLeaf"
                    src="../../assets/icons/folder.svg"
                    class="foldericon"
                  />
                  <img
                    v-else
                    src="../../assets/icons/file.svg"
                    class="fileicon"
                  />
                  <span class="ml-3">
                    {{getSubsLocation(scope.row)}}
                  </span>
                </span>
              </template>
            </el-table-column>

            <el-table-column
              label="訂閱者"
              prop="name"
              width="160"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.group.color)">{{
                  scope.row.group.name
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="需要審核" width="120">
              <template #default="scope">
                <el-switch
                  :value="needApprove(scope.row)"
                  active-text="是"
                  inactive-text="否"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @change="
                    needAppr =>
                      changeApprNeed(needAppr, scope.row, scope.$index)
                  "
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column label="到期日" width="200px">
              <template #default="scope">
                <span
                  v-loading="isSwitchDisabled(scope.$index)"
                >
                  <img
                    v-if="isBlueLight(scope.row)"
                    src="../../assets/icons/blue.svg"
                    class="blueicon"
                  />
                  <img
                    v-else-if="isRedLight(scope.row)"
                    src="../../assets/icons/failure.svg"
                    class="redicon"
                  />
                  <img
                    v-else
                    src="../../assets/icons/success.svg"
                    class="greenicon"
                  />
                </span>
                <el-date-picker
                  :value="scope.row.endDate"
                  :picker-options="pickerOptions"
                  style="width:150px"
                  type="date"
                  value-format="timestamp"
                  size="small"
                  placeholder="指定到期日"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @input="
                    newEndDate =>
                      changeEndDate(newEndDate, scope.row, scope.$index)
                  "
                >
                </el-date-picker>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button
                  type="danger"
                  size="mini"
                  @click="changeSubscription(false, scope.row, scope.$index)"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import moment from "moment-timezone";
import { MAX_DUEDATE, NO_DATE } from "../../appConfig";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import API from "@/api/";
export default {
  mixins: [tagColorsMixin],
  components: {},

  model: {
    prop: "visible",
    event: "toggleVisible",
  },

  created() {
    console.log(`created: deptMemberId = ${this.deptMemberId}`);
    this.sort = this.defaultSortCol;
    this.order = this.defaultOrder;
    if (this.innerVisible) {
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    }
  },

  props: {
    visible: {
      type: Boolean,
    },
    groupId: {
      type: Number,
    },
    groupName: {
      type: String,
    },
  },

  data() {
    return {
      subscriptions: [],
      total: 0,
      offset: 0,
      sort: "",
      order: "descending",

      selectedRow: [],
      isLoading: false,
      disabledSwitchIdx: [],
      defaultSortCol: "subscription.id",
      defaultOrder: "ascending",
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
        //colors: [],
      },
      activeQueryForm: {
        qstr: "",
        //colors: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > MAX_DUEDATE;
        },
        shortcuts: [
          {
            text: "不限制",
            onClick(picker) {
              const date = NO_DATE;
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "weeks")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(3, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一年後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "years")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },

  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },

  methods: {
    isBlueLight(row) {
      const endDate = row.endDate;
      return endDate === NO_DATE;
    },
    isRedLight(row) {
      return row.endDate < Date.now();
    },
    getSubsLocation(row) {
      const lastChar = row.path.slice(-1);
      if (lastChar !== '/') {
        return `${row.path}/${row.asset.name}`;
      } else {
        return `${row.path}${row.asset.name}`;
      }
    },
    changeSubscription(isSubscr, row, index) {
      if (isSubscr) {
        return;
        //p = this.subsAsset(row, index);
      }
      const isChecked = this.selectedRow.find(row => row.member.name === row.member.name);
      this.disabledSwitchIdx.push(index);

      let p = this.singleUnsubsAsset(row, index);
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.subscriptions[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    singleUnsubsAsset(row, index) {
      return this.confirmDel()
        .then(() => {
          this.isLoading = true;
          let p;
          p = this.unsubsAsset(row, index, false, true);
          p.finally(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.activeQueryForm
            ).then(() => (this.isLoading = false));
          });
        })
        .catch(() => {});
    },


    unsubsAsset(row, index, updateStore = true, showMsg = true) {
      return API.subscribe
        .removeSubs(row.id)
        .then(res => {
          if (updateStore) {
            this.subscriptions.splice(index, 1);
          }

          showMsg &&
            this.$message({
              type: "success",
              message: "退訂成功!",
            });
          return res;
        });
    },

    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    changeEndDate(newEndDate, row, index) {
      const effEndDate = newEndDate;
      const isChecked = this.selectedRow.find(selRow => selRow.id === row.id);
      let p;
      this.disabledSwitchIdx.push(index);
      p = this.setEndDate(effEndDate, row, index);
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(
            this.subscriptions[index],
            true
          );

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    setEndDate(newEndDate, row, _, updateStore = true, showMsg = true) {
      const params = {};
      const effIsNeedApprove =  row.isNeedApprove;
      params.isNeedApprove = effIsNeedApprove;
      params.endDate = newEndDate;
      return API.subscribe.changeSubs(row.id, params).then(() => {
        if (updateStore) {
          row.isNeedApprove = effIsNeedApprove;
          row.endDate = newEndDate === NO_DATE ? NO_DATE : newEndDate.toString(),

          showMsg &&
            this.$message({
              type: "success",
              message: "到期日設定成功!",
            });
        }
      });
    },

    changeApprNeed(needAppr, row, index) {
      const isChecked = this.selectedRow.find(selRow => selRow.id === row.id);
      let p;
      this.disabledSwitchIdx.push(index);
      if (needAppr) {
        p = this.setNeedAppr(true, row, index);
      } else {
        p = this.setNeedAppr(false, row, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(
            this.subscriptions[index],
            true
          );

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    setNeedAppr(needAppr, row, _, updateStore = true, showMsg = true) {
      const params = {};
      params.isNeedApprove = needAppr;
      return API.subscribe.setApprNeed(row.id, params).then(() => {
        if (updateStore) {
          row.isNeedApprove = needAppr;

          showMsg &&
            this.$message({
              type: "success",
              message: "審核設定成功!",
            });
        }
      });
    },

    needApprove(row) {
      return row.isNeedApprove;
    },

    isGroupSubs(row) {
      return row.group !== null;
    },

    isChannelSubs(row) {
      return row.subscriptionType === "channel";
    },

    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach(row => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row));
        }
      });

      //this.$refs.dataTable.clearSelection();

      Promise.allSettled(promises)
        .then(results => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push(runningItem[idx].id);
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          this.query(
            this.pageSize,
            this.offset,
            this.sort,
            this.order,
            this.activeQueryForm
          ).then(() => {
            failedItem.forEach(failedId => {
              const failedOne = this.subscriptions.find(
                item => item.id === failedId
              );
              failedOne &&
                this.$refs.dataTable.toggleRowSelection(failedOne, true);
            });
            this.isLoading = false;
          });
        });
    },

    confirmDel() {
      return this.$confirm("此操作將永久刪除所選取的訂閱, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      });
    },

    handleBatchUnsubs() {
      this.confirmDel()
        .then(() => {
          const isSkipped = () => {};
          const actCallback = row => this.unsubsAsset(row, null, false, false);
          this.batchHandler(isSkipped, actCallback, "批次刪除成功");
        })
        .catch(() => {});
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.isLoading = true;
      this.query(
        this.pageSize,
        0,
        this.sort,
        this.order,
        this.activeQueryForm
      ).then(() => (this.isLoading = false));
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },

    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },

    query(max, offset, sort, order, params) {
      const newParams = {
        max: max,
        offset: offset,
        sort,
        order,
        group: this.groupId,
        ...params,
      };

      return API.subscribe
        .list(newParams)
        .then(res => {
          if (res.status === 200) {
            this.subscriptions = res.data[0];
            this.total = res.data[1];
            this.offset = offset;
            return res;
          } else {
            return Promise.reject(res);
          }
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },

    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },

    sortChange(args) {
      if (args.order === null) {
        this.sort = this.defaultSortCol;
        this.order = this.defaultOrder;
      } else {
        this.sort = args.prop;
        this.order = args.order;
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {},
  },
};
</script>

<style scoped>
.phoneicon {
  width: 28px;
  height: 28px;
  margin-left: -5px;
  margin-right: 2px;
}
.personicon {
  width: 24px;
  height: 24px;
  margin-left: 2px;
  margin-right: 2px;
}
.groupicon {
  width: 28px;
  height: 28px;
  margin-left: 0px;
  margin-right: 2px;
}
</style>
